import { Container, Divider } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Box, Grid } from "@mui/material";
import axios from "axios";
import {
  AutoCompleteComponent,
  BalanceCard,
  CustomTable,
  ImportDocumentModal,
  ModalError,
  ModalSuccess,
  MonthYearRangePicker,
  Page,
  PrimaryButton,
  SearchTextInput,
  SelectInput,
  YearPicker,
} from "components";
import { ButtonGroupTop } from "components/atoms/Button";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import {
  arrayToCommaSeparatedString,
  formatPayloadDate,
  getErrors,
} from "utils";
import {
  columnTableInvoice,
  optionsInvoiceStatus,
  optionsInvoiceType,
} from "./Components/ConstantInvoice";
import { ModalTotalInvoice } from "./Components/ModalInvoice";

const Invoice = () => {
  const classes = globalStyles();
  const location = useLocation();
  const urlPath = location.pathname;
  const isComposerInvoice = urlPath === "/admin/composer-invoice";
  const isFinance = useSelector(
    ({ userState }) => userState?.role?.roles_for === "finance"
  );
  const history = useHistory();
  const isFirstLoad = useRef(true);
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const urlParams = new URLSearchParams(location.search);
  const paramsSearch = urlParams?.get("search") || "";
  const paramsPage = urlParams?.get("page") || 1;
  const paramsSize = urlParams?.get("size") || 10;
  const paramsStatus = urlParams?.get("status") || "";
  const paramsYear = urlParams?.get("year");
  const paramsDSP = urlParams?.get("dsp_id");
  const paramsComposer = urlParams?.get("composer_id");
  const paramsStart = urlParams?.get("start_date");
  const paramsEnd = urlParams?.get("end_date");
  const paramsType = urlParams?.get("type");
  const pageTitle = `${isComposerInvoice ? "Composer" : "Sales"} Invoice`;
  const pageUrl = `${isComposerInvoice ? "composer" : "sales"}-invoice`;
  const [optionClient, setOptionClient] = useState([]);
  const [optionUser, setOptionUser] = useState([]);
  const [loadingPage, setLoadingPage] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: Number(paramsPage) || 1,
    size: Number(paramsSize) || 10,
    search: paramsSearch || "",
    status: paramsStatus || "",
    type: paramsType || "",
    sort: "",
    year: Number(paramsYear) || moment().year(),
    ...(isComposerInvoice
      ? {
          composer_id: Number(paramsComposer) || "",
          start_date:
            paramsStart && paramsStart !== "null" ? moment(paramsStart) : null,
          end_date:
            paramsEnd && paramsEnd !== "null" ? moment(paramsEnd) : null,
          generated_by: "",
        }
      : {
          dsp_id: Number(paramsDSP) || "",
        }),
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const [dataSummary, setDataSummary] = useState([{}, {}, {}]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalFilter, setModalFilter] = useState("");
  const [modalUploadVisible, setModalUploadVisible] = useState(false);
  const [selectedSalesInvoices, setSelectedSalesInvoice] = useState([]);
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingDownloadButton, setLoadingDownloadButton] = useState(false);
  const [cloudFiles, setCloudFiles] = useState([]);

  const handleChangePageParams = (value, key) => {
    urlParams.set(key, value);
    history.replace({
      pathname: location.pathname,
      search: urlParams.toString(),
    });
  };
  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
    handleChangePageParams(value, key);
    if (key !== "page") {
      handleChangePageParams(1, "page");
    }
  };

  const handleChangeYear = year => {
    handleChangeQueryParams(year, "year");
    const { start_date, end_date } = queryParams;
    if (start_date && end_date) {
      const newStartDate = moment(start_date)
        .startOf("month")
        .year(year);
      let newEndDate = moment(end_date)
        .endOf("month")
        .year(year);
      let maxAllowedDate;
      const currentYear = moment().year();

      if (year === currentYear) {
        maxAllowedDate = moment().endOf("month");
      } else {
        maxAllowedDate = moment()
          .year(year)
          .endOf("year");
      }

      if (newEndDate > maxAllowedDate) {
        newEndDate = maxAllowedDate;
      }

      handleChangeStartDate(newStartDate);
      handleChangeEndDate(newEndDate);
    }
  };
  const handleChangeStartDate = date => {
    handleChangeQueryParams(date, "start_date");
  };
  const handleChangeEndDate = date => {
    handleChangeQueryParams(date, "end_date");
  };

  const getClientList = async () => {
    const url = isComposerInvoice
      ? "publisher/transaction/v2/composer-invoice/list-composer"
      : "master/all-client";
    try {
      const res = await axios.get(`${hardBaseUrl}/${url}`, {
        headers,
        params: isComposerInvoice
          ? { page: 1, size: 10, search: "", year: queryParams?.year }
          : {},
      });
      const newOptions = res?.data?.data?.map(item => ({
        ...item,
        id: isComposerInvoice ? item?.composer_id : item?.dsp_id,
        label: isComposerInvoice ? item?.composer_name : item?.dsp_name,
      }));
      setOptionClient(newOptions);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getDataSummary = async () => {
    const { dsp_id, year, composer_id } = queryParams;
    try {
      const res = await axios.get(
        `${hardBaseUrl}/publisher/transaction/v2/${pageUrl}/cards`,
        {
          headers,
          params: {
            year,
            ...(isComposerInvoice ? { composer_id } : { dsp_id }),
          },
        }
      );
      const order = ["total", "paid", "unpaid"];
      const modifiedData = res?.data?.data?.map(item => ({
        ...item,
        type: isComposerInvoice
          ? summaryTypeComposer[item.card_name]
          : summaryType[item.card_name] || "unknown",
      }));
      modifiedData.sort(
        (a, b) => order.indexOf(a.type) - order.indexOf(b.type)
      );
      setDataSummary(modifiedData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const { start_date, end_date, ...restQueryParams } = queryParams;
      const res = await axios.get(
        `${hardBaseUrl}/publisher/transaction/v2/${pageUrl}`,
        {
          headers,
          params: {
            ...restQueryParams,
            start_date: formatPayloadDate(start_date),
            end_date: formatPayloadDate(end_date),
          },
        }
      );
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.size || 1);
      setTableTotalPage(pageCount);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const debounceDataTable = useCallback(
    debounce(() => {
      getDataTable();
    }, 500),
    [queryParams]
  );
  const getOptionUser = async () => {
    try {
      const res = await axios.get(
        `${hardBaseUrl}/publisher/transaction/v2/composer-invoice/list-generated-by`,
        { headers, params: { page: 1, size: 10, search: "" } }
      );
      const newOptions = res?.data?.data?.map(item => ({
        ...item,
        id: item?.user_id,
        label: item?.user_name,
      }));
      setOptionUser(newOptions);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const fetchData = async () => {
    setLoadingPage(true);
    const promises = [getDataSummary(), getDataTable(), getOptionUser()];
    if (isFirstLoad.current) {
      promises.push(getClientList());
    }

    try {
      await Promise.all(promises);
    } catch (error) {
      ModalError(error, "Error fetching data");
    } finally {
      setLoadingPage(false);
      isFirstLoad.current = false;
    }
  };
  const handleDelete = async id => {
    let url = `${hardBaseUrl}/publisher/transaction/v2/sales-invoice/${id}`;
    if (isComposerInvoice) {
      url = `${hardBaseUrl}/publisher/transaction/v2/composer-invoice/${id}`;
    }
    try {
      await axios.delete(url, { headers });
      ModalSuccess("Successfully delete data").then(() => fetchData());
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const handleDownloadDocuments = async () => {
    setLoadingDownloadButton(true);
    try {
      const res = await axios.get(
        `${hardBaseUrl}/publisher/transaction/v2/composer-invoice/bulk-template`,
        {
          headers,
          params: {
            sales_invoice_id: arrayToCommaSeparatedString(
              selectedSalesInvoices,
              "sales_invoice_id"
            ),
          },
        }
      );
      setModalVisible(false);
      ModalSuccess(res?.data?.data).then(() =>
        history.push("/admin/download-monitoring")
      );
    } catch (error) {
      ModalError(getErrors(error));
    } finally {
      setLoadingDownloadButton(false);
    }
  };
  const handleDragFiles = async acceptedFiles => {
    if (!acceptedFiles?.length) {
      return;
    }
    const payloadInit = { filenames: acceptedFiles?.map(item => item?.path) };
    try {
      const res = await axios.post(
        `${hardBaseUrl}/storage/upload/init`,
        payloadInit,
        { headers }
      );
      const uploadData = res?.data?.data || [];
      setCloudFiles(uploadData);

      await Promise.all(
        uploadData.map((item, index) => {
          const file = acceptedFiles[index];

          return axios.put(item.url, file, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": file.type,
            },
          });
        })
      );
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    }
  };
  const handleUploadComposerInvoice = async acceptedFiles => {
    const localFiles = { filenames: acceptedFiles?.map(item => item?.name) };
    const filteredFiles = cloudFiles?.filter(tempFile =>
      localFiles?.filenames?.includes(tempFile?.original_name)
    );
    console.log("filteredFiles", filteredFiles);
    const payload = {
      temp_filepath: filteredFiles[0]?.filename,
      original_filename: filteredFiles[0]?.original_name,
    };

    setLoadingButton(true);
    try {
      await axios.post(
        `${hardBaseUrl}/publisher/transaction/v2/composer-invoice/bulk-upload`,
        payload,
        {
          headers,
        }
      );
      ModalSuccess("Successfully Upload Composer Invoice").then(() =>
        history.push("/admin/upload-monitoring?type=CIU")
      );
    } catch (error) {
      ModalError(getErrors(error));
    } finally {
      setLoadingButton(false);
    }
  };
  useEffect(() => {
    const isSearching = Boolean(queryParams?.search);
    if (isSearching) {
      debounceDataTable();
      return () => {
        debounceDataTable.cancel();
      };
    } else {
      fetchData();
    }
  }, [queryParams, debounceDataTable]);

  return (
    <Page className={classes.root} title={pageTitle}>
      <Container maxWidth={false}>
        <HeaderTitle
          title={pageTitle}
          breadcrumbData={breadcrumbData({ pageTitle, pageUrl })}
        />
        <ButtonGroupTop />
        <Divider className={classes?.flatDivider} />
        <Grid container columnGap={2} my="16px">
          <Grid item>
            <AutoCompleteComponent
              options={optionClient}
              placeholder={`All ${isComposerInvoice ? "Composer" : "Client"}`}
              value={
                optionClient.find(option =>
                  isComposerInvoice
                    ? option.id === queryParams?.composer_id
                    : option.id === queryParams?.dsp_id
                ) || null
              }
              label={isComposerInvoice ? "Composer" : "Client"}
              onChange={value =>
                handleChangeQueryParams(
                  value,
                  isComposerInvoice ? "composer_id" : "dsp_id"
                )
              }
              size="small"
              width={300}
              disabled={loadingPage}
            />
          </Grid>
          <Grid item>
            <YearPicker
              label="Year"
              onChange={handleChangeYear}
              value={queryParams?.year}
              width={200}
              disabled={loadingPage}
            />
          </Grid>
        </Grid>
        <Box display="flex" overflow="auto" columnGap={2} mt="16px">
          {dataSummary?.map((item, index) => {
            const isUnpaid = item?.type === "unpaid";
            return (
              <Box flexShrink={0} key={index}>
                <BalanceCard
                  title={item?.card_name}
                  value={item?.total_invoice}
                  infoButton
                  tooltipTitle={`${pageTitle} Status ${
                    summaryAtrributes(isComposerInvoice)?.find(
                      attribute => attribute?.key === item?.type
                    )?.tooltip_title
                  }`}
                  onClick={() => {
                    setModalVisible(true);
                    setModalTitle(item?.card_name);
                    setModalFilter(
                      summaryAtrributes(isComposerInvoice)?.find(
                        attribute => attribute?.key === item?.type
                      )?.filter
                    );
                  }}
                  subTitle={`${item?.total_document} Docs`}
                  description={isUnpaid ? "Total" : "This Year"}
                  changeIndicator={!isUnpaid && item?.trend_this_year}
                  loading={loadingPage}
                  minWidth={350}
                  subTitleJustify={isUnpaid && "space-between"}
                  backgroundColor={isUnpaid && "#712D20"}
                />
              </Box>
            );
          })}
        </Box>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          my={2}
          rowSpacing={1}
        >
          <Grid item>
            <Grid container columnSpacing={1} alignItems="center">
              <Grid item>
                <SearchTextInput
                  placeholder="Search"
                  value={queryParams?.search}
                  onChange={e =>
                    handleChangeQueryParams(e?.target?.value, "search")
                  }
                  disabled={loadingPage}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container columnGap={1} rowGap={1} alignItems="center">
              {isComposerInvoice && (
                <Grid item>
                  <AutoCompleteComponent
                    placeholder="All User"
                    label="Generated By"
                    options={optionUser}
                    value={
                      optionUser?.find(
                        item => item?.id === queryParams?.generated_by
                      ) || null
                    }
                    onChange={value =>
                      handleChangeQueryParams(value, "generated_by")
                    }
                    size="small"
                    width={300}
                    disabled={loadingPage}
                  />
                </Grid>
              )}
              <Grid item>
                {isComposerInvoice ? (
                  <MonthYearRangePicker
                    key={queryParams?.year}
                    label="Period"
                    startDate={queryParams?.start_date}
                    handleChangeStartDate={handleChangeStartDate}
                    endDate={queryParams?.end_date}
                    handleChangeEndDate={handleChangeEndDate}
                    clear
                    width={300}
                    syncYear
                    predefinedYear={queryParams?.year}
                    disabled={loadingPage}
                  />
                ) : (
                  <SelectInput
                    label="Type"
                    placeholder="None"
                    value={queryParams?.type}
                    onChange={e =>
                      handleChangeQueryParams(e?.target?.value, "type")
                    }
                    options={optionsInvoiceType}
                    optionKey="value"
                    optionLabel="name"
                    width={200}
                    disabled={loadingPage}
                  />
                )}
              </Grid>
              <Grid item>
                <SelectInput
                  label="Status"
                  placeholder="None"
                  value={queryParams?.status}
                  onChange={e =>
                    handleChangeQueryParams(e?.target?.value, "status")
                  }
                  options={optionsInvoiceStatus}
                  optionKey="value"
                  optionLabel="name"
                  width={200}
                  disabled={loadingPage}
                />
              </Grid>
              {isComposerInvoice && !isFinance && (
                <Grid item>
                  <PrimaryButton
                    label="Upload Invoice"
                    onClick={() => setModalUploadVisible(true)}
                    size="large"
                    disabled={loadingPage}
                  />
                </Grid>
              )}
              {!isFinance && (
                <Grid item>
                  <PrimaryButton
                    label="Add Invoice"
                    onClick={() => history.push(`/admin/${pageUrl}/add`)}
                    size="large"
                    startIcon={<Add />}
                    disabled={loadingPage}
                  />
                </Grid>
              )}
              {isComposerInvoice && !isFinance && (
                <Grid item>
                  <PrimaryButton
                    label="Add Payment"
                    onClick={() => history.push("/admin/payment/add")}
                    size="large"
                    startIcon={<Add />}
                    disabled={loadingPage}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Divider className={classes?.divider} />
        <CustomTable
          isLoading={loadingPage}
          columnTable={columnTableInvoice({ isComposerInvoice })}
          data={dataTable}
          page={queryParams?.page}
          pageSize={queryParams?.size}
          pageCount={tableTotalPage}
          handleChangePage={(_, page) => handleChangeQueryParams(page, "page")}
          handleChangePageSize={e =>
            handleChangeQueryParams(e?.target?.value, "size")
          }
          isHaveAction
          disabledEdit={item => item?.status !== "draft" || isFinance}
          tooltipEdit="Update"
          handleEdit={item =>
            history.push(
              `/admin/${pageUrl}/edit/${
                isComposerInvoice ? item?.id : item?.publisher_transaction_id
              }`
            )
          }
          tooltipView="View"
          handleView={item =>
            history.push({
              pathname: `/admin/${pageUrl}/${
                isComposerInvoice ? item?.id : item?.publisher_transaction_id
              }`,
              state: { type: item?.type },
            })
          }
          disabledDelete={item => item?.status !== "draft"}
          tooltipDelete="Delete"
          deleteConfirmation
          deleteConfirmationKey="invoice_number"
          handleDelete={item =>
            handleDelete(
              isComposerInvoice ? item?.id : item?.publisher_transaction_id
            )
          }
        />
        {modalVisible && (
          <ModalTotalInvoice
            open={modalVisible}
            onClose={() => setModalVisible(false)}
            title={modalTitle}
            params={queryParams}
            filter={modalFilter}
            isComposerInvoice={isComposerInvoice}
            searchPlaceholder={!isComposerInvoice && "Search Invoice"}
          />
        )}
        {modalUploadVisible && (
          <ImportDocumentModal
            modalTitle="Upload Composer Invoice"
            open={modalUploadVisible}
            onClose={() => setModalUploadVisible(false)}
            loadingButton={loadingButton}
            fileType=".xlsx, .xls"
            handleDownloadButton={handleDownloadDocuments}
            loadingDownloadButton={loadingDownloadButton}
            handleDragFiles={handleDragFiles}
            onSubmit={handleUploadComposerInvoice}
            onChangeSalesInvoice={setSelectedSalesInvoice}
            selectedInvoices={selectedSalesInvoices}
            setSelectedInvoices={setSelectedSalesInvoice}
            disabledDownloadButton={!selectedSalesInvoices?.length}
          />
        )}
      </Container>
    </Page>
  );
};

const breadcrumbData = ({ pageTitle, pageUrl }) => [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Transaction",
    link: `/admin/${pageUrl}`,
  },
  {
    label: pageTitle,
    active: true,
  },
];
const summaryType = {
  "Total Sales Invoice": "total",
  "Total Sales Invoice Paid": "paid",
  "Total Sales Invoice Unpaid": "unpaid",
};
const summaryTypeComposer = {
  "Total Composer Invoice": "total",
  "Total Composer Invoice Paid": "paid",
  "Total Composer Invoice Unpaid": "unpaid",
};
const summaryAtrributes = isComposerInvoice => [
  {
    key: "total",
    tooltip_title: "Approved and Paid",
    filter: `paid,approved${
      isComposerInvoice ? ",waiting_for_approval_payment" : ""
    }`,
  },
  { key: "paid", tooltip_title: "Paid", filter: "paid" },
  {
    key: "unpaid",
    tooltip_title: "Unpaid",
    filter: `approved${
      isComposerInvoice ? ",waiting_for_approval_payment" : ""
    }`,
  },
];
export default Invoice;
